import { Effect, Schema } from "effect";

import { IoId } from "./IO.ts";
import { Position } from "./Position.ts";
import { SchemaRef } from "./SchemaRef.ts";

export const NodeId = Schema.String.pipe(Schema.brand("NodeId"));
export type NodeId = typeof NodeId.Type;

export const Model = Schema.Struct({
  id: NodeId,
  name: Schema.String,
  properties: Schema.Record(Schema.String, Schema.Json),
  inputDefaults: Schema.Record(Schema.String, Schema.Json).pipe(
    Schema.withDecodingDefaultKey(Effect.succeed({})),
  ),
  foldPins: Schema.Boolean.pipe(Schema.withDecodingDefaultKey(Effect.succeed(false))),
  splitScopeOutputs: Schema.optional(Schema.Array(IoId)),
  schema: SchemaRef,
  position: Position,
});
export type Model = typeof Model.Type;

export const CreateInput = Schema.Struct({
  name: Schema.optional(
    Schema.String.annotate({ description: "Optional display name for the node." }),
  ),
  properties: Schema.optional(
    Schema.Record(Schema.String, Schema.Json).annotate({
      description:
        "Property values keyed by schema property ID. Resource-backed properties use a matching configured resource ID.",
    }),
  ),
  inputDefaults: Schema.optional(
    Schema.Record(Schema.String, Schema.Json).annotate({
      description: "Default values keyed by input port ID.",
    }),
  ),
  foldPins: Schema.optional(Schema.Boolean),
  splitScopeOutputs: Schema.optional(Schema.Array(IoId)),
  schema: SchemaRef,
  position: Schema.optional(Position),
});
export type CreateInput = typeof CreateInput.Type;

export class NotFoundError extends Schema.TaggedError<NotFoundError>()("NodeNotFoundError", {
  id: Schema.String,
}) {}

export * as Node from "./Node.ts";
